module.exports = __webpack_public_path__ + "static/media/01_sensor-101-module.5c3656a0.mp4";